import React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';

import * as Ui from '../../Ui';
import Form from '../../utils/Form';
import ExternalLink from '../../common/components/Link';

const Wrapper = styled.div`
	width: 350px;
	background-color: #fff;
	box-shadow: 0 1.5px 4px rgba(0, 0, 0, 0.24),
				0 1.5px 6px rgba(0, 0, 0, 0.12);
`;

const Header = styled.div`
	padding: 20px;
`;

const Content = styled.div`
	padding: 0 20px 20px 20px;
`;

const Logo = styled.img`
	display: block;
	width: 280px;
	margin: 0 auto;
`;

const Margin = styled.div`
	margin-bottom: 16px;
`;

const MarginRight = styled.span`
	margin-right: 8px;
`;

const ErrorText = styled.p`
	height: ${props => (props.show ? 24 : 0)}px;
	text-align: center;
	color: #ea5b62;
	transition: height 0.3s ease;
`;

const Divider = styled.div`
	height: 1px;
	background-color: #e2e2e2;
`;

const RetainBox = styled.div`
	margin-bottom: 16px;
	color: #9e9e9e;
`;

const Footer = styled.div`
	padding: 20px;
`;

const LinkMargin = styled.div`
	margin-bottom: 8px;
`;

const LoginForm = ({ fields, error, loading, onFieldChange, onSubmit }) => (
	<Wrapper>

		<Header>
			<Margin>
				<Logo src={require('../../../assets/logo.png')} />
			</Margin>
		</Header>

		<Content>

			<Margin>
				<ErrorText show={error}>{error}</ErrorText>
			</Margin>

			<Form onSubmit={onSubmit}>

				<Margin>
					<Ui.TextField
						label="Identifiant"
						name="login"
						value={fields.login}
						onChange={onFieldChange}
					/>
				</Margin>

				<Margin>
					<Ui.PasswordField
						label="Mot de passe"
						name="password"
						value={fields.password}
						onChange={onFieldChange}
					/>
				</Margin>

				<RetainBox>
					<label>
						<MarginRight>
							<Ui.Checkbox
								name="retainIDs"
								checked={fields.retainIDs}
								onClick={onFieldChange}
							/>
						</MarginRight>
						Mémoriser mes identifiants
					</label>
				</RetainBox>

				<Ui.PrimaryButton fillWidth submit loading={loading}>

					Connexion
				</Ui.PrimaryButton>
			</Form>
		</Content>

		<Divider />

		<Footer>
			<LinkMargin>
				<a href="http://www.legallais.com/user/forgotpassword/">
					<Ui.FlatPrimaryButton>
						Mot de passe oublié ?
					</Ui.FlatPrimaryButton>
				</a>
			</LinkMargin>
			<a href="http://www.legallais.com/user/signin/">
				<Ui.FlatPrimaryButton className="link">
					S'enregistrer
				</Ui.FlatPrimaryButton>
			</a>
		</Footer>

	</Wrapper>
);

export default LoginForm;



// WEBPACK FOOTER //
// ./src/js/Login/client/LoginForm.js